import React from 'react'

import CheckBoxWithBackground from 'app/components/CheckBoxWithBackground'
import { DayButtonProps } from './DayButton.interface'

import './styles.scss'

const bc = 'work-day-button'

export const DayButton: React.FC<DayButtonProps> = ({ selected, text, input }) => {
  return <CheckBoxWithBackground type="checkbox" className={bc} text={text} {...input} marked={selected} />
}

// (
//   <button
//     type="button"
//     className={cn(bc, {
//       [`${bc}--checked`]: checked,
//     })}
//     {...rest}
//   />
// )
